import { render } from "./vip-index.vue?vue&type=template&id=4af1d964&scoped=true"
import script from "./vip-index.vue?vue&type=script&lang=js"
export * from "./vip-index.vue?vue&type=script&lang=js"

import "./vip-index.vue?vue&type=style&index=0&id=4af1d964&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af1d964"]])

export default __exports__